export default __webpack_public_path__ + "static/csm2-02-b5273c77874a3bb111d0404cf8adbe65.png";